import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-5 text-center">
      <span className="pointer-events-none absolute select-none font-display text-[16rem] font-extrabold leading-none text-bone/[0.04]">222</span>
      <p className="font-mono text-[10px] tracking-[0.35em] text-fade">CHECKOUT PAUSED</p>
      <h1 className="mt-6 max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-bone sm:text-6xl">
        The path is still there.
      </h1>
      <p className="mt-6 max-w-md text-sm font-light text-neutral-400">Your cart was kept exactly as you left it. Whenever you're ready — right place, right time.</p>
      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link to="/shop" data-testid="cancel-return-shop" className="bg-bone px-8 py-4 font-display text-xs font-extrabold uppercase tracking-[0.25em] text-ink hover:opacity-90">
          RETURN TO SHOP
        </Link>
        <Link to="/" data-testid="cancel-return-home" className="border border-bone/40 px-8 py-4 font-mono text-xs tracking-[0.25em] text-bone hover:bg-bone hover:text-ink">
          HOME
        </Link>
      </div>
    </div>
  );
}
